<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="primary"
        dark
        class="my-1 text-none"
        v-bind="attrs"
        v-on="on"
        rounded
      >
        <v-icon left> mdi-plus </v-icon>
        Nuevo Perfil
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="text-body-1 primary--text">Nuevo Perfil</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <validation-alert :validationErrors="validationErrors" />
          <v-form ref="form" v-model="isValidFormDialog" lazy-validation>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  v-model="editedItem.app_id"
                  :items="applications"
                  :rules="applicationRules"
                  item-text="name"
                  item-value="id"
                  label="Aplicación"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="editedItem.name"
                  :rules="nameRules"
                  label="Nombre"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  v-model="editedItem.description"
                  name="description"
                  label="Descripción"
                  :rules="descriptionRules"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey lighten-1" text @click="close()"> Cancelar </v-btn>
        <v-btn color="blue" text @click="save()"> Guardar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ValidationAlert from "@/components/global/ValidationAlert.vue";
import { $EventBus } from "@/main";
export default {
  name: "CreateProfileDialog",

  props: {},

  data: () => ({
    isValidFormDialog: false,
    applicationRules: [(v) => !!v || "Campo requerido"],
    nameRules: [(v) => !!v || "Campo requerido"],
    descriptionRules: [(v) => !!v || "Campo requerido"],
    dialog: false,
    editedItem: {
      app_id: "",
      name: "",
      description: "",
    },
    defaultItem: {
      app_id: "",
      name: "",
      description: "",
    },
    isLoading: false,
  }),

  computed: {
    applications() {
      return this.$store.getters["applications/getApplicationsList"];
    },
    validationErrors() {
      return this.$store.getters["profiles/getValidationErrors"];
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
      if (val) {
        this.$store.dispatch("applications/getApplicationsList");
      }
    },
  },

  methods: {
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.$refs.form.reset();
      });
    },

    showSnack(color = "", text = "") {
      $EventBus.$emit("showSnack", { color, text });
    },

    async save() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        try {
          await this.$store.dispatch("profiles/saveProfile", this.editedItem);
          this.showSnack("green", "Se ha registrado satisfactoriamente");
          this.$emit("resetFilter");
          this.close();
        } catch (error) {}
        this.isLoading = false;
      }
    },
  },
  components: {
    ValidationAlert,
  },
};
</script>
